import { ReactNode, useEffect } from 'react'
import { motion, AnimatePresence } from 'motion/react'
import { X } from 'lucide-react'

interface ModalOverlayProps {
  open: boolean
  onClose?: () => void
  children: ReactNode
  borderColor?: string
  borderGradient?: string
  /** Скрыть верхнюю X-кнопку (например, для критичных модалок без выхода) */
  hideCloseBtn?: boolean
}

export function ModalOverlay({ open, onClose, children, borderColor, borderGradient, hideCloseBtn }: ModalOverlayProps) {
  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden'
    else document.body.style.overflow = ''
    return () => { document.body.style.overflow = '' }
  }, [open])

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          onClick={onClose}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 100,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0,0,0,0.55)',
            fontFamily: 'Roboto, sans-serif',
            padding: 24,
          }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.92, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.92, y: 20 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
            style={{
              width: '100%',
              maxWidth: 358,
              borderRadius: 24,
              padding: 24,
              background: 'rgba(255,255,255,0.85)',
              backdropFilter: 'blur(24px)',
              WebkitBackdropFilter: 'blur(24px)',
              border: borderColor ? `2px solid ${borderColor}` : '1px solid rgba(255,255,255,0.5)',
              boxShadow: '0 24px 64px rgba(0,0,0,0.15)',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            {borderGradient && (
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  borderRadius: 24,
                  padding: 2,
                  background: borderGradient,
                  WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                  WebkitMaskComposite: 'xor',
                  maskComposite: 'exclude',
                  pointerEvents: 'none',
                }}
              />
            )}
            {/* Универсальная кнопка закрытия — справа сверху */}
            {!hideCloseBtn && onClose && (
              <button
                onClick={onClose}
                aria-label="Закрыть"
                style={{
                  position: 'absolute', top: 10, right: 10,
                  width: 32, height: 32, borderRadius: '50%',
                  border: 'none', background: 'rgba(0,0,0,0.06)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  cursor: 'pointer', zIndex: 2,
                }}
              >
                <X size={16} color="#6B7B8D" />
              </button>
            )}
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
